export default "__VITE_ASSET__bc7453bc__"